/* core components */
import React, { useContext } from "react";

import Autocomplete from "@material-ui/lab/Autocomplete";
import { AutocompleteValidator } from "utils/Validators/CommonValidator";
import TextField from "@material-ui/core/TextField";
import { UserInfoContext } from "contexts/users";
import { Validate } from "utils/Validators/Validate";
import conf from "config/env.conf.js";
import getDefaultValue from "utils/DefaultValue";
/* custom components */
import useFetch from "hooks/useFetch";

const ListboxProvince = props => {
  const userInfo = useContext(UserInfoContext);

  let isCenter = userInfo.userInfo.iscenter;
  const [, setError] = React.useState();
  const [valid, setValid] = React.useState();
  const [helperText, setHelperText] = React.useState("");

  let endPoint = "?";
  if (props.areaEctSelected) {
    endPoint += `area_id=${props.areaEctSelected.id}`;
  }

  const [isLoading, fetchData] = useFetch(
    conf.END_POINT_URL + "/ms/provinces" + endPoint,
    []
  );

  let content = (
    <TextField disabled label="เลือกจังหวัด" margin="normal" fullWidth />
  );

  let data = [];

  if (!isLoading && fetchData !== null && fetchData.data !== undefined) {
    data = fetchData.data.map(v => {
      return { id: v.province_id, value: v.province_name };
    });
    if (props.controll) {
      data = [{ id: 0, value: "" }, ...data];
    }
    data = [{ id: 0, value: "" }, ...data];
    // data.push({ id: 0, value: "เลือกจังหวัด" });
  }

  if (data.length > 0) {
    content = (
      <Autocomplete
        disabled={props.disabled === undefined ? !isCenter : props.disabled}
        id={props.id}
        options={data}
        defaultValue={getDefaultValue(data, props.defaultValue)}
        value={props.value && props.value.id === 0 ? data[0] : props.value}
        getOptionLabel={option => option.value}
        getOptionSelected={(option, value) => option.id === value.id}
        onChange={AutocompleteValidator(
          props.onChange,
          props.validators,
          setError,
          setHelperText
        )}
        renderInput={params => {
          return (
            <TextField
              {...params}
              label={props.title ? props.title : "เลือกทุกจังหวัด"}
              margin="normal"
              error={valid}
              fullWidth
              helperText={helperText}
              inputProps={{
                autoComplete: "new-password",
                //   autoComplete: "off",
                ...params.inputProps
              }}
              onChange={Validate(
                params.inputProps.value,
                props.required,
                setValid
              )}
              required={props.required}
            />
          );
        }}
        {...props.customProps}
      />
    );
  }
  return content;
};
export default ListboxProvince;
